@if (toastConfig$ | async; as toastConfig) {
  <div
    class="toast"
    [ngClass]="'toast_' + toastConfig.type"
    [style.--duration]="(toastConfig.durationMs ?? defaultDurationMs) + 'ms'"
  >
    <div class="toast_header">
      <i class="pi" [ngClass]="iconList[toastConfig.type]"></i>
      <div>
        <h3 class="m-0">{{ toastConfig.title }}</h3>
        @if (toastConfig.subtitle) {
          <p>{{ toastConfig.subtitle }}</p>
        }
      </div>
      <button
        class="pi pi-times"
        (click)="close()"
        type="button"
        aria-label="Close toast notification"
      ></button>
    </div>
    @if (toastConfig.message) {
      <div class="toast_body">
        {{ toastConfig.message }}
      </div>
    }
  </div>
}
